import { useEffect } from 'react';

const HubSpotForm = () => {
  useEffect(() => {
    // Charger le script HubSpot
    const script = document.createElement('script');
    script.src = 'https://js-eu1.hsforms.net/forms/embed/147712458.js';
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup si nécessaire
      const existingScript = document.querySelector('script[src="https://js-eu1.hsforms.net/forms/embed/147712458.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section id="contact" className="py-24 px-4 md:px-8 bg-[#F5F5F5]">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center px-4 py-2 rounded-full bg-[#2A41E5]/10 border border-[#2A41E5]/20 mb-6">
            <span className="text-sm text-[#2A41E5] font-medium">Contact</span>
          </div>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            Prêt à accélérer votre croissance ?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Discutons de vos enjeux commerciaux. Un premier échange pour comprendre votre contexte et voir comment nous pouvons vous aider.
          </p>
        </div>

        {/* Formulaire HubSpot */}
        <div className="bg-white rounded-2xl p-8 md:p-12 shadow-lg border border-gray-100">
          <div 
            className="hs-form-frame" 
            data-region="eu1" 
            data-form-id="268830f4-7284-4db6-a590-4fda22b26e31" 
            data-portal-id="147712458"
          />
        </div>
      </div>
    </section>
  );
};

export default HubSpotForm;
